import * as React from 'react';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Fab from "@mui/material/Fab";
import EditIcon from '@mui/icons-material/Edit';
import './DashboardAdmin.css'
import { StyledEngineProvider } from "@mui/material/styles";
import {DialogContent, TextField} from "@mui/material";
import {DataGrid, GridCellEditStopReasons} from '@mui/x-data-grid';
import {useEffect, useState} from "react";
import Divider from '@mui/material/Divider';
import {FxmsData} from "../datas/FxData";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import FxDashboard from "../components/FxDashBoard";
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';
import Switch from '@mui/material/Switch';
import {GadgetDashboard} from "../components/GadgetDashboard";
import axios from 'axios';
import {FxFlowGojsEditor} from "../components/Gadgets/charts/FxFlowGojsEditor";

export default function PipeAdmin() {
    const [open, setOpen] = React.useState(false);
    const [editOpen, setEditOpen] = React.useState(false);
    const [createOpen, setCreateOpen] = React.useState(false);
    const [dashbNo, setDashbNo] = React.useState(0);
    const [ruleGrp, setRuleGrp] = useState([])
    //대시보드 생성 인자 시작//
    const [selectGrp, setSelectGrp] = useState([])
    const [editGrp, setEditGrp] = useState([])
    const [name, setName] = useState('')
    const [desc, setDesc] = useState('')
    const [isUse, setIsUse] = useState(true)
    const [checkErrMsg, setCheckErrMsg] = useState('')
    //대시보드 생성 인자 끝
    const [ruleChangeOpen, setRuleChangeOpen] = useState(false)
    const [selectedRuleChange, setSelectedRuleChange] = useState([])
    const [tempRowForRuleChange, setTempRowForRuleChange] = useState({})
    const [ruleChangeMode, setRuleChangeMode] = useState('')
    const [loading, setLoading] = useState(false)

    const [columns, setColumns] = useState([
        {field: 'id', headerName: '번호',align:'center',flex:1,headerAlign: 'center'},
        {field: 'pipeName', headerName: '이름',align:'center',flex:2,headerAlign: 'center',editable: true},
        {field: 'pipeDescr', headerName: '설명',align:'center',flex:3,headerAlign: 'center',editable: true},
        // {field: 'useYn', headerName: '사용여부',align:'center',flex:1,headerAlign: 'center',
        //     renderCell:(params)=>{
        //         return <Button variant={params.value === "Y"?"contained":"outlined"} color="primary"
        //                         onClick={handleIsUseDashboard.bind(this,params.row.id,params)}
        //         >{
        //             params.value==="Y"?"사용중":"미사용"
        //         }</Button>}},
        // {field: 'dashbViewUgrpList', headerName: '조회권한',align:'center',flex:3,headerAlign: 'center',
        //     renderCell:(params)=>{
        //     if(params.value){
        //         if(params.value.length > 0 ){
        //             return (<div onClick={()=>{handleRuleChangeOpen(params.row,'dashbViewUgrpList')}}>
        //                 {params.value.map(x=> x ?
        //                     <span style={{fontWeight:100,color:'white',float:'left',border:"1px white solid",borderRadius:'11px',margin:'5px',padding:'5px'}} key={x.ugrpNo}>{x.ugrpName}</span>
        //                     :'')}
        //                 </div>
        //             )
        //         }else{
        //             return 'not ready'
        //         }
        //     }
        //     }},
        // {field: 'dashbEditUgrpList', headerName: '편집권한',align:'center',flex:3,headerAlign: 'center',
        //     renderCell:(params)=>{
        //         if(params.value){
        //             if(params.value.length > 0 ){
        //                 return (<div onClick={()=>{handleRuleChangeOpen(params.row,'dashbEditUgrpList')}}>
        //                         {params.value.map(x=> x ?
        //                             <span style={{fontWeight:100,color:'white',float:'left',border:"1px white solid",borderRadius:'11px',margin:'5px',padding:'5px'}} key={x.ugrpNo}>{x.ugrpName}</span>
        //                             :'')}
        //                     </div>
        //                 )
        //             }else{
        //                 return 'not ready'
        //             }
        //         }
        //     }
        // },
        {field: 'engId', headerName: '에너지코드',align:'center',flex:1,headerAlign: 'center'},
        {field: 'pipeClCd', headerName: '타입',align:'center',flex:1,headerAlign: 'center'},
        {field: 'pipeId', headerName: '편집',align:'center',flex:1,headerAlign: 'center',
            renderCell:(params)=>{
                return <Button onClick={handleEditOpen.bind(this,params.value)} variant="contained" color="primary">편집</Button>
            }
        },
        ])
    const [rows, setRows] = useState([])
    const [filteredRows, setFilteredRows] = useState([
        { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 }
    ])
    useEffect(()=>{
        handleClickOpen()
    },[])

    const handleRuleChangeOpen = (row,column) => {
        setSelectedRuleChange(row[column].map(x=>x.ugrpNo))
        setTempRowForRuleChange(row)
        setRuleChangeMode(column)
        setRuleChangeOpen(true)
    }

    const getDashboardList = () => {
        FxmsData.get('feFacPipe/list').then(list=>{
            let data = list.data
                data.map((x,index)=>{
                x.id = index
            })
            setRows(data)
            setFilteredRows(data)
            setLoading(false)
        })
        //pipe 목록 가져오기
        // FxmsData.get('fxUrUgrp').then(list=>{
        //     setRuleGrp(list.data)
        //     //대시보드 목록 가져오기
        //     axios.get('http://175.123.142.155:11880/getPipe').then(res=>{
        //         if(res.status == 200){
        //             let data = res.data
        //             data.map((x,index)=>{
        //                 x.id = index
        //                 x["dashbEditUgrpList"] = x["dashbEditUgrpList"].map(x => list.data.find(y => y.ugrpNo === x))
        //                 x["dashbViewUgrpList"] = x["dashbViewUgrpList"].map(x => list.data.find(y => y.ugrpNo === x))
        //             })
        //             setRows(data)
        //             setFilteredRows(data)
        //             setLoading(false)
        //         }else{
        //             alert(res.statusText)
        //         }
        //     })
        // })


    }
    const handleIsUseDashboard = (dashbNo,event) =>{
        setLoading(true)
        let editObj = {}
        if(event.row.useYn == 'Y'){
            editObj.useYn = 'N'
        }else if(event.row.useYn == 'N'){
            editObj.useYn = 'Y'
        }
        editObj.dashbName = event.row.dashbName
        editObj.dashbdescr = event.row.dashbDescr
        editObj.dashbViewUgrpList = event.row.dashbViewUgrpList.filter(x=>x!==undefined).map(x=>x.ugrpNo)
        editObj.dashbEditUgrpList = event.row.dashbEditUgrpList.filter(x=>x!==undefined).map(x=>x.ugrpNo)
        // FxmsData.PUT('fxUiDash/dash/'+dashbNo,editObj).then(res=>{
        //     if(res.statusText === "OK"){
        //         getDashboardList()
        //     }else{
        //         alert(res.statusText)
        //     }
        // })
    }
    const handleEditGrpChangeSave = (event) =>{
        console.log(event.target.value)
    }
    const handleClickOpen = () => {
        setLoading(true)
        setOpen(true);
        getDashboardList()
    };
    const handleEditOpen = (dashbNo,event) => {
        setDashbNo(dashbNo)
        setEditOpen(true)
    }
    const handleCreateOpen = () => {
        setCreateOpen(true)
    }
    const handleClose = () => {
        setFilteredRows(rows)
        setOpen(false);
    };
    const handleEditClose = () => {
        setEditOpen(false);
    };
    const handleCreateClose = () => {
        setSelectGrp([])
        setEditGrp([])
        setCreateOpen(false);
    };
    const searchDashboards = (event) => {
        const results = rows.filter(x=>{
            if((x.pipeName.toLowerCase()+x.pipeDescr.toLowerCase()+x.pipeId.toLowerCase()+x.pipeClCd.toLowerCase()).includes(event.target.value.toLowerCase())){
                return x
            }
        })
        setFilteredRows(results)
    }
    const handleSelectGrpChange = (event) => {
        const {target: { value }} = event;
        setSelectGrp(typeof value === 'string' ? value.split(',') : value,);
    };
    const handleSelectRuleChange = (event) => {
        const {target: { value }} = event;
        setSelectedRuleChange(typeof value === 'string' ? value.split(',') : value,);
    }
    const handleEditGrpChange = (event) => {
        const {target: { value }} = event;
        setEditGrp(typeof value === 'string' ? value.split(',') : value,);
    };
    const handleSaveNewDashboard =  () => {
        let obj = {}
        if (selectGrp.length == 0) {
            setCheckErrMsg('권한을 설정하세요')
        } else if (editGrp.length == 0) {
            setCheckErrMsg('권한을 설정하세요')
        } else if (name == '') {
            setCheckErrMsg('이름을 설정하세요')
        } else if (desc == '') {
            setCheckErrMsg('설명을 설정하세요')
        } else {
            setCreateOpen(false)
            obj.dashbName = name
            obj.dashbdescr = desc
            obj.dashbViewUgrpList = selectGrp
            obj.dashbEditUgrpList = editGrp
            obj.useYn = isUse ? 'Y' : 'N'
            axios.put('http://175.123.142.155:11880/savePipe', obj)
            getDashboardList()
        }
        setTimeout(() => {
            setCheckErrMsg('')
        }, 2000)

    }
    const handleShowAllChange = (event) => {
        if(event.target.checked){
            setFilteredRows(rows)
        }else{
            setFilteredRows(rows.filter(x=>x.useYn==="Y"))
        }

    }
    const saveRuleChange = () => {
        setLoading(true)
        setRuleChangeOpen(false)
        let obj = {}
        obj.dashbNo = tempRowForRuleChange.dashbNo
        obj.dashbName = tempRowForRuleChange.dashbName
        obj.dashbdescr = tempRowForRuleChange.dashbDescr
        obj.useYn = tempRowForRuleChange.useYn
        if(ruleChangeMode.includes('View')){
            obj.dashbViewUgrpList = selectedRuleChange
            obj.dashbEditUgrpList = tempRowForRuleChange.dashbEditUgrpList.filter(x=>x!==undefined).map(x=>x.ugrpNo)
        }else{
            obj.dashbViewUgrpList = tempRowForRuleChange.dashbViewUgrpList.filter(x=>x!==undefined).map(x=>x.ugrpNo)
            obj.dashbEditUgrpList = selectedRuleChange
        }
        // FxmsData.PUT('fxUiDash/dash/'+obj.dashbNo,obj).then((res)=>{
        //     if(res.statusText === "OK"){
        //         getDashboardList()
        //     }else{
        //         alert(res.statusText)
        //     }
        // })

    }
    const handleSaveChanges = () => {
        console.log(filteredRows)
    }
    const updateData = React.useCallback((newRow, oldRow) => new Promise((resolve, reject) => {
        let isChanged = false
        if(newRow.pipeName != oldRow.pipeName){
            isChanged = true
        }
        if(newRow.pipeDescr != oldRow.pipeDescr){
            isChanged = true
        }
        if(newRow.pipeClCd != oldRow.pipeClCd){
            isChanged = true
        }
        if(newRow.engId != oldRow.engId){
            isChanged = true
        }
        if(isChanged){
            let obj = {}
            obj.pipeName = newRow.pipeName
            obj.pipeDescr = newRow.pipeDescr
            obj.pipeId = newRow.pipeId
            obj.engId = newRow.engId
            obj.pipeClCd = newRow.pipeClCd
            setLoading(true)
            // feFacPipe/ui/
            FxmsData.PUT('feFacPipe/'+newRow.pipeId,obj).then((res)=>{
                if(res.status === 200){
                    getDashboardList()
                }else{
                    alert(res.status)
                }
            })
        }
         resolve(newRow)
            }),
        [],
    );
    return (
        <StyledEngineProvider injectFirst>

            {/* 관리자 페이지 다이어로그 */}
            {loading ?
                <Box sx={{zIndex:9999, transform:'translate(-50%, -50%)',position:'fixed',top:'50%',left:'50%'}}><CircularProgress size={100} color='secondary' /></Box> :
                ''}
            <div className='dashboard_admin_basic'>검색조건</div>
            <div className='dashboard_admin_basic'>
                <TextField onChange={searchDashboards} label="검색" variant="outlined" sx={{ input: { color: 'white' } }} />
            </div>
            <Divider sx={{ bgcolor: "primary.light" , m:'22'}}/>
            <div className='dashboard_admin_basic'>검색결과
                <FormControlLabel style={{float:'right',margin:'3px'}} control={<Switch onChange={handleShowAllChange} defaultChecked />} label="모두보기" />
                {/*<Button style={{float:'right',margin:'3px'}}  onClick={handleCreateOpen} variant="contained" color="primary">생성</Button>*/}
                <Button style={{float:'right',margin:'3px'}}  onClick={handleSaveChanges} variant="contained" color="primary">저장</Button>

            </div>

            <div className='dashboard_admin_basic'>
                <DataGrid
                    getRowHeight={() => 'auto'}
                    rowHeight={100}
                    className="dashboard_admin_table"
                    rows={filteredRows}
                    columns={columns}
                    pageSize={5} autoHeight={true}
                    rowsPerPageOptions={[5]}
                    checkboxSelection={false}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    processRowUpdate={updateData}
                    onProcessRowUpdateError={React.useCallback((error) => {setCheckErrMsg(error.message);}, [])}
                />
            </div>
            {/*<Dialog onClose={handleClose} open={open} fullWidth={true} maxWidth={'xl'}>*/}
            {/*    <DialogTitle>대시보드 관리</DialogTitle>*/}
            {/*    <DialogContent>*/}
            {/*        */}
            {/*    </DialogContent>*/}
            {/*</Dialog>*/}
            {/* 조회/편집 권한 수정 다이어로그*/}
            <Dialog onClose={()=>setRuleChangeOpen(false)} open={ruleChangeOpen}>
                <DialogContent>
                    <FormControl fullWidth >
                        <Select className="dashboard_admin_bottomMargin"
                                fullWidth multiple
                                value={selectedRuleChange}
                                onChange={handleSelectRuleChange}
                                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selectedRuleChange.map((x) =>(<Chip key={x} label={ruleGrp.find(y=>y.ugrpNo===x).ugrpName} color="primary" variant="outlined" />)
                                        )}
                                    </Box>
                                )}>
                            {ruleGrp.map((x) => (
                                <MenuItem className="dashboard_admin_select" key={x.ugrpNo} value={x.ugrpNo}>{x.ugrpName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Button onClick={saveRuleChange} variant={"contained"} >저장</Button>
                </DialogContent>
            </Dialog>
            {/* 신규 생성 다이어로그 */}
            <Dialog onClose={handleCreateClose} open={createOpen}>
                <DialogTitle>
                   <Typography component="div" className="dashboard_admin_title">
                        배관 생성
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <div className="dashboard_admin_basic">
                         <TextField onChange={(e)=>{setName(e.target.value)}} className="dashboard_admin_bottomMargin" fullWidth label="배관명" variant="outlined" sx={{ input: { color: 'white' } }}/>
                         <TextField onChange={(e)=>{setDesc(e.target.value)}} className="dashboard_admin_bottomMargin" fullWidth label="배관 설명" variant="outlined" sx={{ input: { color: 'white' } }}/>
                        <FormControl fullWidth >
                            <InputLabel>조회권한 그룹</InputLabel>
                            <Select className="dashboard_admin_bottomMargin"
                                fullWidth multiple
                                value={selectGrp}
                                onChange={handleSelectGrpChange}
                                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selectGrp.map((x) => (<Chip key={x} label={ruleGrp.find(y=>y.ugrpNo===x).ugrpName} color="primary" variant="outlined" />))}
                                    </Box>
                                )}>
                                {ruleGrp.map((x) => (
                                    <MenuItem className="dashboard_admin_select" key={x.ugrpNo} value={x.ugrpNo}>{x.ugrpName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth >
                            <InputLabel>편집권한 그룹</InputLabel>
                            <Select className="dashboard_admin_bottomMargin"
                                fullWidth
                                multiple
                                value={editGrp}
                                onChange={handleEditGrpChange}
                                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {editGrp.map((x) => (<Chip key={x} label={ruleGrp.find(y=>y.ugrpNo===x).ugrpName} color="primary" variant="outlined" />))}
                                    </Box>
                                )}>
                                {ruleGrp.map((x) => (
                                    <MenuItem className="dashboard_admin_select" key={x.ugrpNo} value={x.ugrpNo}>{x.ugrpName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="dashboard_admin_basic">
                        <FormControlLabel control={<Checkbox checked={isUse} onChange={(e)=>{setIsUse(e.target.checked)}} />} label="사용여부" />
                    </div>
                    <div>
                        <div className="dashboard_admin_errMsg">{checkErrMsg}</div>
                        <div><Button onClick={handleSaveNewDashboard} className='dashboard_admin_newDashButton' variant="contained" color="primary">저장</Button></div>
                    </div>


                </DialogContent>
            </Dialog>
            {/* 대시보드 편집 다이어로그 */}
            <Dialog onClose={handleEditClose} open={editOpen} fullScreen>
                <DialogContent>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleEditClose}
                    ><Typography component="div" className="dashboard_admin_title">
                        배관 편집
                    </Typography>
                        <CloseIcon />
                    </IconButton>
                    <Divider sx={{ bgcolor: "primary.light",mb:3}}/>
                    <FxFlowGojsEditor dashbNo={dashbNo} item={[]} editable={true}/>
                    {/*<FxDashboard uiGrpNo={dashbNo} />*/}
                </DialogContent>
            </Dialog>
        </StyledEngineProvider>
    );
}